import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const FILE_CUSTOMER_CANCEL_CHEQUE = "FILE_CUSTOMER_CANCEL_CHEQUE";
export const FILE_CUSTOMER_CANCEL_CHEQUE_LOADING =
"FILE_CUSTOMER_CANCEL_CHEQUE_LOADING";
export const FILE_CUSTOMER_CANCEL_CHEQUE_LOADING_FAILED =
"FILE_CUSTOMER_CANCEL_CHEQUE_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const FileCancelChequeLoading = ms => ({
    type: FILE_CUSTOMER_CANCEL_CHEQUE_LOADING,
    payload: ms
    });
    
    export const FileCancelChequeLoadingFailed = ms => ({
    type: FILE_CUSTOMER_CANCEL_CHEQUE_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function FileCancelCheque(obj) {
        const request = axios.post(
            `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/fileCheque/chequeCancel`, obj,{
                headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
              });
    
    
    return dispatch => {

    dispatch(FileCancelChequeLoading());
    request
    .then(response => {   
  
    if (response.status == 200 || response.status == 201) {
   /*   console.log(response,"response FileCancelCheque") */
    dispatch({
    type: FILE_CUSTOMER_CANCEL_CHEQUE,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        FileCancelChequeLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(FileCancelChequeLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(FileCancelChequeLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(FileCancelChequeLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


